import { Button, Modal } from 'antd';
import styled from 'styled-components';

export const AnalysisButton = styled(Button)`
  background: #178efd !important;
  color: #ffff !important;
  padding: 5px;
`;
export const lightTheme = {
  text: 'black',
  even: '#7a8793',
  odd: '#bdc0c2',
  hover: '#dedede'
};

export const StyledTable = styled.table`
   //background:#bfbfbf !important;
     caption-side: top;
   
   
     color: ${(props) => props.theme.text} !important;
     thead[class*="ant-table-thead"] th{
       background-color: #214972 !important;
       color: #fff !important;
       text-align: center;
     }
     width: 100%;
     /* border-collapse: separate; */
     /* border-spacing: 5px 10px; */
   
     caption-side: bottom;
     /* empty-cell: show | hide;  */
     /* empty-cell is a property of table or the cells themselves */
   
     /* vertical-align: baseline | sub | super | text-top | 
                   text-bottom | middle | top | bottom | 
                   <percentage> | <length> */
   
     /* tbody {
       vertical-align: top;
     }              */
     td,
     th {
       border: none;
     }
     /* td,
     th {
         color:${(props) => props.theme.text} !important;
       border: 1px solid red;
      
     } */
   
     td {
       padding: 11px 10px;
   
     }
     .ant-table-thead > tr > th{
       font-weight:bold !important
        // color:red !important
     }
     text[style] {
       font-weight:bold !important
       color: ${(props) => props.theme.text} !important;
    }
     tbody tr {
       :nth-of-type(odd) {
         background-color:${(props) => props.theme.odd} !important;
       }
       :hover {
         background-color:${(props) => props.theme.hover} !important; 
       }
     }
     tbody tr {
       :nth-of-type(even) {
         background-color:${(props) => props.theme.even} !important;
       }
       :hover {
         background-color:${(props) => props.theme.hover} !important; 
       }
       text-align: center;
     }
     thead > tr {
       color: ${(props) => props.theme.text} !important;
       background-color: #262626 !important;
     }
     caption {
       padding: 5px;
       font-weight: bold;
     }
   `;

export const ChildTablesGroup = styled.div`
  background: rgb(26, 54, 82);
  padding: 30px;
  width: 100%;
  // margin: 20px;
  text-align: center;
  line-height: 75px;
`;

export const StyledModal = styled(Modal)`
  width: 90vw !important;

  .ant-modal-content {
    border-radius: 20px;
    background: #1a3652;
  }

  .ant-modal-header {
    background: #1a3652;
    border: 0px;
  }
  .ant-modal-title {
    color: #ffffff !important;
    
  }
  .ant-form-item-required {
    color: #ffffff !important;
  }

  .ant-modal-close {
    color: white !important;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
  }

  .ant-modal-footer {
    padding: 10px 16px;
    text-align: right;
    background: transparent;
    border-radius: 0 0 2px 2px;
    border-top: 0;
  }
`;
